import http from 'util/http'

/** 获取藏经阁下面的分类 */
export function getCategory() {
  return http.get('/newxyrj/public/article/buddhisttopic/category', {
    to_show: 0,
  })
}
/**
 * 通过分类获取文章
 * @param {number} id 分类ID
 * @param {object} param0 分页
 * @param {object} param0.pageindex 页码
 * @param {object} param0.pagesize 页数
 * @param {number} sort 排序 0 | 1
 */
export function getList(
  id: number,
  { pageindex, pagesize = 10 }: { pageindex: number; pagesize?: number },
  sort?: number,
) {
  return http.get('/newxyrj/public/article/category/id', {
    category_id: id,
    pageindex,
    pagesize,
    sort,
  })
}
